export const SOURCE_OF_ASSIGNMENT_AI_MATCH = 'ai-match';

export const DEFAULT_PRIORITY_COLOR = "#2684FF";
export const DEFAULT_PRIORITY_BACKGROUND_COLOR = "#F7FAFF";

// Icon mapping for dynamic icon loading
export const ICON_MAP = {
  // Calendar related
  'calendar': 'IconCalendar',
  'date': 'IconCalendar',
  'time': 'IconCalendar',
  'schedule': 'IconCalendar',
  'IconCalendar': 'IconCalendar',
  
  // Tag related
  'tag': 'IconTag',
  'label': 'IconTag',
  'category': 'IconTag',
  'IconTag': 'IconTag',
  
  // Building/Company related
  'building': 'IconBuilding',
  'company': 'IconBuilding',
  'organization': 'IconBuilding',
  'account': 'IconBuilding',
  'IconBuilding': 'IconBuilding',
  
  // Target/Sales related
  'target': 'IconTarget',
  'sales': 'IconTarget',
  'opportunity': 'IconTarget',
  'deal': 'IconTarget',
  'IconTarget': 'IconTarget',
  
  // Ticket/Support related
  'ticket': 'IconTicket',
  'support': 'IconTicket',
  'issue': 'IconTicket',
  'bug': 'IconTicket',
  'IconTicket': 'IconTicket',
  
  // Message/Communication related
  'message': 'IconMessageCircle',
  'chat': 'IconMessageCircle',
  'communication': 'IconMessageCircle',
  'IconMessageCircle': 'IconMessageCircle',
  
  // Article related
  'article': 'IconArticle',
  'IconArticle': 'IconArticle',
  
  // User related
  'user': 'IconUser',
  'person': 'IconUser',
  'profile': 'IconUser',
  'IconUser': 'IconUser',
  
  // List/Default
  'list': 'IconList',
  'default': 'IconList',
  'IconList': 'IconList'
} as const;